import { useAccessDenied } from '@/lib/stores/useAccessDenied'

/**
 * Phase 1 RBAC §1.2: graceful 403 handling.
 *
 * Mounted once at the application root. Renders a modal whenever the axios
 * response interceptor flips `useAccessDenied` after the backend returns 403,
 * so direct URL navigation to a restricted page (or a stale role view) shows
 * a clear "access denied" UI instead of an opaque error toast or blank page.
 */
export function AccessDeniedOverlay() {
  const { shown, message, dismiss } = useAccessDenied()

  if (!shown) return null

  return (
    <div
      data-testid="access-denied-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="access-denied-title"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm"
      onClick={dismiss}
    >
      <div
        className="mx-4 max-w-md rounded-lg border border-gray-200 bg-white p-6 shadow-xl dark:border-zinc-800 dark:bg-zinc-900"
        onClick={(event) => event.stopPropagation()}
      >
        <h2
          id="access-denied-title"
          className="text-lg font-semibold text-gray-900 dark:text-gray-50"
        >
          Access denied
        </h2>
        <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">{message}</p>
        <div className="mt-6 flex justify-end gap-2">
          <button
            type="button"
            onClick={dismiss}
            className="rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-zinc-900"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  )
}
